import { useState } from "react";
import {
  Flex,
  Box,
  VStack,
  HStack,
  Text,
  AspectRatio,
  FormControl,
  FormLabel,
  Input,
  Select,
  Spinner,
} from "@chakra-ui/react";
import router from "next/router";
import Head from "next/head";
import MainButton from "../components/MainButton";
import MainFooter from "../components/Layout/MainFooter";
import HomeTitle from "../components/Home/HomeTitle";
import gasApi from "../store/gasApi";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import GCPImage from "components/GCPImage";

function Partner() {
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("");
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [link, setLink] = useState("");
  return (
    <>
      <Head>
        <title key="title">
          成為 UDRIVE 合作夥伴，友善環境，賺取額外收入｜悠駕 UDRIVE
        </title>
        <meta
          key="description"
          name="description"
          content="合作夥伴/任何店家/飯店/網紅/Youtuber/推廣大使/人脈王 一起加入吧！"
        />
        <meta
          key="og_title"
          property="og:title"
          content="成為 UDRIVE 合作夥伴，友善環境，賺取額外收入｜悠駕 UDRIVE"
        />
        <meta
          key="og_description"
          property="og:description"
          content="合作夥伴/任何店家/飯店/網紅/Youtuber/推廣大使/人脈王 一起加入吧！"
        />
        <meta
          key="og_url"
          property="og:url"
          content="https://www.udrive.city/partner"
        />
      </Head>
      <Flex flexDir={{ base: "column", md: "row" }}>
        <AspectRatio ratio="1" flex="1 0 50%" maxW="700px">
          <GCPImage src="/images/partner/main.jpg" alt="main img" />
        </AspectRatio>
        <Box bgColor="#fff" flex="1 0 50%">
          <Flex
            bgColor="#fff"
            justify="center"
            align="center"
            w="100%"
            h="100%"
            px="20px"
            py="50px"
          >
            <Box maxW="400px" textAlign="center">
              <VStack px="30px" w="100%">
                <HomeTitle fontWeight="400">成為 UDRIVE 合作夥伴</HomeTitle>
                <Text
                  textAlign="center"
                  fontWeight="400"
                  fontSize="15px"
                  lineHeight="1.8"
                  letterSpacing="0.05em"
                  mt={{ base: "15px", md: "0" }}
                >
                  UDRIVE 在尋找具有影響力的推廣大使
                  <br />
                  我們一同努力加速全球轉向永續能源
                  <br />
                  讓台灣逐步邁向零排放的美好未來
                </Text>
              </VStack>
              <MainButton
                mt="40px"
                bgColor="#4F69FF"
                border="none"
                color="#fff"
                w="200px"
                rounded="30px"
                fontSize="14px"
                onClick={() =>
                  router.push({
                    hash: "apply",
                  })
                }
              >
                申請成為夥伴
              </MainButton>
            </Box>
          </Flex>
        </Box>
      </Flex>
      <Box py={{ base: "50px", lg: "80px" }} bgColor="#FBFBFB">
        <VStack px="30px" w="100%">
          <HomeTitle fontWeight="400">我們缺的就是你</HomeTitle>
          <Text
            textAlign="center"
            fontWeight="400"
            fontSize="15px"
            lineHeight="1.8"
            letterSpacing="0.05em"
            mt={{ base: "15px", md: "0" }}
          >
            只要具有影響力，不管是何方的推坑高手，我們一起來讓環境更美好
          </Text>
        </VStack>
        <Flex flexWrap="wrap" mt="50px" px="30px" maxW="960px" mx="auto">
          <Box
            flex="1 1 280px"
            mx="10px"
            mb={{ base: "20px", md: "30px" }}
            p="20px"
            textAlign="center"
          >
            <Box w="50%" mx="auto">
              <GCPImage
                src="/images/partner/travel-iso-premium.png"
                alt="main img"
              />
            </Box>
            <Text fontSize="20px" mt="15px" mb="5px" textAlign="center">
              飯店業者
            </Text>
            <Text fontSize="15px" opacity="0.75">
              Udrive 為飯店提供高級租車服務，訂房＋租車雙贏模式！
            </Text>
          </Box>
          <Box
            flex="1 1 280px"
            mx="10px"
            mb={{ base: "20px", md: "30px" }}
            p="20px"
            textAlign="center"
          >
            <Box w="50%" mx="auto">
              <GCPImage
                src="/images/partner/mail-iso-premium.png"
                alt="main img"
              />
            </Box>
            <Text fontSize="20px" mt="15px" mb="5px" textAlign="center">
              企業合作
            </Text>
            <Text fontSize="15px" opacity="0.75">
              常常有商務出差用車需求嗎？加入 Udrive 獲得回饋
            </Text>
          </Box>
          <Box
            flex="1 1 280px"
            mx="10px"
            mb={{ base: "20px", md: "30px" }}
            p="20px"
            textAlign="center"
          >
            <Box w="50%" mx="auto">
              <GCPImage
                src="/images/partner/thumb-up-iso-premium.png"
                alt="main img"
              />
            </Box>
            <Text fontSize="20px" mt="15px" mb="5px" textAlign="center">
              社群網紅
            </Text>
            <Text fontSize="15px" opacity="0.75">
              我們需要你熱愛分享生活，提供真實心得給粉絲！
            </Text>
          </Box>
          <Box
            flex="1 1 280px"
            mx="10px"
            mb={{ base: "20px", md: "30px" }}
            p="20px"
            textAlign="center"
          >
            <Box w="50%" mx="auto">
              <GCPImage
                src="/images/partner/video-camera-iso-premium.png"
                alt="main img"
              />
            </Box>
            <Text fontSize="20px" mt="15px" mb="5px" textAlign="center">
              YouTuber/Podcaster
            </Text>
            <Text fontSize="15px" opacity="0.75">
              專長拍影片或錄製節目嗎？歡迎分享體驗特斯拉快感賺取被動收入！
            </Text>
          </Box>
          <Box
            flex="1 1 280px"
            mx="10px"
            mb={{ base: "20px", md: "30px" }}
            p="20px"
            textAlign="center"
          >
            <Box w="50%" mx="auto">
              <GCPImage
                src="/images/partner/picture-iso-premium.png"
                alt="main img"
              />
            </Box>
            <Text fontSize="20px" mt="15px" mb="5px" textAlign="center">
              部落客/作家
            </Text>
            <Text fontSize="15px" opacity="0.75">
              邀請流量王、粉絲忠誠度高的你加入！
            </Text>
          </Box>
          <Box
            flex="1 1 280px"
            mx="10px"
            mb={{ base: "20px", md: "30px" }}
            p="20px"
            textAlign="center"
          >
            <Box w="50%" mx="auto">
              <GCPImage
                src="/images/partner/crown-iso-color.png"
                alt="main img"
              />
            </Box>
            <Text fontSize="20px" mt="15px" mb="5px" textAlign="center">
              人脈王
            </Text>
            <Text fontSize="15px" opacity="0.75">
              如果你是特斯拉粉絲，也有許多同好，還等什麼？
            </Text>
          </Box>
        </Flex>
      </Box>
      <Box
        py={{ base: "50px", lg: "80px" }}
        pt={{ base: "30px", lg: "50px" }}
        maxW="950px"
        mx="auto"
      >
        <HomeTitle fontWeight="400">您將擁有...</HomeTitle>
        <VStack
          w="100%"
          spacing={{ base: "10px", md: "20px" }}
          p="10px"
          mt="30px"
        >
          <HStack
            w="100%"
            boxShadow="0 10px 30px 0 rgba(0, 0, 0, .1)"
            rounded="10px"
            overflow="hidden"
            p="10px"
          >
            <Flex
              flex={{ base: "0 0 50px", md: "0 0 100px", lg: "0 0 150px" }}
              px="10px"
              justify="center"
              align="center"
            >
              <GCPImage src="/images/partner/icon_rebate.png" alt="rebate" />
            </Flex>
            <Box p={{ base: "5px", md: "25px" }}>
              <Text fontSize="20px" mb={{ base: "5px", md: "10px" }}>
                實質訂單回饋
              </Text>
              <Text fontSize="15px" opacity="0.75">
                只要有人透過推廣連結下單，推廣大使可獲得每筆訂單金額固定 ％
                數回饋，提供後台管理，訂單資料透明，輕鬆獲得持續性被動收入。
              </Text>
            </Box>
          </HStack>
          <HStack
            w="100%"
            boxShadow="0 10px 30px 0 rgba(0, 0, 0, .1)"
            rounded="10px"
            overflow="hidden"
            p="10px"
          >
            <Flex
              flex={{ base: "0 0 50px", md: "0 0 100px", lg: "0 0 150px" }}
              px="10px"
              justify="center"
              align="center"
            >
              <GCPImage src="/images/partner/icon_vip.png" alt="vip" />
            </Flex>
            <Box p={{ base: "5px", md: "25px" }}>
              <Text fontSize="20px" mb={{ base: "5px", md: "10px" }}>
                專屬尊榮服務
              </Text>
              <Text fontSize="15px" opacity="0.75">
                成為推廣大使、合作夥伴，可搶先收到 UDRIVE
                悠駕最新優惠資訊，且租車皆享有優惠。
              </Text>
            </Box>
          </HStack>
          <HStack
            w="100%"
            boxShadow="0 10px 30px 0 rgba(0, 0, 0, .1)"
            rounded="10px"
            overflow="hidden"
            p="10px"
          >
            <Flex
              flex={{ base: "0 0 50px", md: "0 0 100px", lg: "0 0 150px" }}
              px="10px"
              justify="center"
              align="center"
            >
              <GCPImage src="/images/partner/icon_popular.png" alt="main img" />
            </Flex>
            <Box p={{ base: "5px", md: "25px" }}>
              <Text fontSize="20px" mb={{ base: "5px", md: "10px" }}>
                社群免費曝光
              </Text>
              <Text fontSize="15px" opacity="0.75">
                舉凡 UDRIVE 悠駕官網、USPACE
                App、社群媒體，皆可成為推廣大使的互惠宣傳管道，將有機會獲得 50
                萬潛在粉絲。
              </Text>
            </Box>
          </HStack>
          <HStack
            w="100%"
            boxShadow="0 10px 30px 0 rgba(0, 0, 0, .1)"
            rounded="10px"
            overflow="hidden"
            p="10px"
          >
            <Flex
              flex={{ base: "0 0 50px", md: "0 0 100px", lg: "0 0 150px" }}
              px="10px"
              justify="center"
              align="center"
            >
              <GCPImage src="/images/partner/icon_planting.png" alt="main img" />
            </Flex>
            <Box p={{ base: "5px", md: "25px" }}>
              <Text fontSize="20px" mb={{ base: "5px", md: "10px" }}>
                淨零排放運具電動化轉型推手
              </Text>
              <Text fontSize="15px" opacity="0.75">
                您會是全球在做電動化轉型重要的推手，與我們一起友善環境，為歷史寫下篇章！
              </Text>
            </Box>
          </HStack>
        </VStack>
      </Box>
      <Box bgColor="#4F69FF" color="#fff" id="apply" mt="-50px" pt="50px">
        <Box py={{ base: "50px", lg: "80px" }} maxW="980px" mx="auto">
          <VStack px="30px" w="100%">
            <HomeTitle fontWeight="400">來合作吧！</HomeTitle>
            <Text
              textAlign="center"
              fontWeight="400"
              fontSize="15px"
              lineHeight="1.8"
              letterSpacing="0.05em"
              mt={{ base: "15px", md: "0" }}
            >
              我們會定期審核，並主動與您聯繫！
            </Text>
          </VStack>
          <VStack
            p="20px"
            bgColor="#FFF"
            rounded="5px"
            boxShadow="0 22px 35px 0px rgba(33,53,168, 0.5)"
            color="#333"
            mt="30px"
            maxW="700px"
            w="95%"
            mx="auto"
            spacing="20px"
            pos="relative"
          >
            {loading && (
              <Flex
                pos="absolute"
                left="0"
                top="0"
                w="100%"
                h="100%"
                justify="center"
                align="center"
                zIndex="1"
                bgColor="rgba(255, 255, 255, .6)"
              >
                <Spinner />
              </Flex>
            )}
            <FormControl>
              <FormLabel>您的身份</FormLabel>
              <Select
                placeholder="請選擇您的類別"
                h="50px"
                onChange={(e) => {
                  setType(e.target.value);
                }}
                value={type}
              >
                <option value="飯店業者">飯店業者</option>
                <option value="企業合作">企業合作</option>
                <option value="社群網紅/KOL">社群網紅/KOL</option>
                <option value="媒體/部落客">媒體/部落客</option>
                <option value="Youtuber">Youtuber</option>
                <option value="Podcaster">Podcaster</option>
                <option value="人脈王">人脈王</option>
                <option value="其他業者">其他業者</option>
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel>公司/個人名稱</FormLabel>
              <Input
                h="50px"
                onChange={(e) => setTitle(e.target.value)}
                value={title}
              />
            </FormControl>
            <FormControl>
              <FormLabel>相關連結</FormLabel>
              <Input
                h="50px"
                onChange={(e) => setLink(e.target.value)}
                value={link}
              />
              <Text fontSize="13px" mt="10px">
                請提供公司網址、社群媒體(需為公開頁面)、飯店官網等等連結供審核
              </Text>
            </FormControl>
            <FormControl>
              <FormLabel>合作簡述</FormLabel>
              <Input
                h="50px"
                onChange={(e) => setDesc(e.target.value)}
                value={desc}
              />
              <Text fontSize="13px" mt="10px">
                簡單說明您覺得可行的合作框架或是其他備註！
              </Text>
            </FormControl>
            <Flex py="20px" justify="end">
              <MainButton
                disabled={!type || title === "" || link === ""}
                bgColor="#4F69FF"
                border="none"
                color="#fff"
                w="200px"
                rounded="30px"
                fontSize="14px"
                onClick={() => {
                  setLoading(true);
                  const mailtoLink = `mailto:marketing@uspace.city?subject=${encodeURIComponent(
                    "UDRIVE 合作推廣計畫 - " + type
                  )}&body=${encodeURIComponent(
                    `公司/個人名稱：${title}\n相關連結：${link}\n合作簡述：${desc}`
                  )}`;
                  window.location.href = mailtoLink;
                  setLoading(false);
                  // gasApi
                  //   .postPartner({
                  //     type,
                  //     title,
                  //     description: desc,
                  //     link,
                  //     utm: router.query ? JSON.stringify(router.query) : "",
                  //   })
                  //   .then((resp) => {
                  //     if (resp.data.success) {
                  //       setType("");
                  //       setTitle("");
                  //       setDesc("");
                  //       setLink("");
                  //       alert("送出成功，請靜候佳音！");
                  //     }
                  //     return;
                  //   })
                  //   .then(() => setLoading(false));
                }}
              >
                送出申請
              </MainButton>
            </Flex>
          </VStack>
        </Box>
      </Box>
      <MainFooter />
    </>
  );
}

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["common"])),
    },
  };
}
export default Partner;
